module.exports = __webpack_public_path__ + "static/img/alipaycode.e9b1d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alipaycode.png
// module id = Ocdd
// module chunks = 1